var _path, _path2, _path3, _polygon;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPpt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.55,0H24.68V256H231.32V61.77Zm4.37,25.48L205.84,57.4H173.92Zm42.47,215.6h-176V14.92H159v57.4h57.39Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.64,117.29H63.41v52H75.78V148.81h7.86c10.42,0,18.28-6.78,18.28-15.76S93.89,117.29,83.64,117.29Zm-.51,21H75.78V127.79h7.35c4.12,0,6.13,1.72,6.13,5.26C89.26,137.8,85,138.31,83.13,138.31Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.12,117.29H108.9v52h12.37V148.81h7.85c10.42,0,18.28-6.78,18.28-15.76S139.37,117.29,129.12,117.29Zm-.5,21h-7.35V127.79h7.35c4.12,0,6.13,1.72,6.13,5.26C134.75,137.8,130.46,138.31,128.62,138.31Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "153.56 127.78 167.75 127.78 167.75 169.33 180.11 169.33 180.11 127.78 194.37 127.78 194.37 117.29 153.56 117.29 153.56 127.78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPpt);
export default __webpack_public_path__ + "static/media/icon-ppt.1e441589.svg";
export { ForwardRef as ReactComponent };